export const IMAGE_MAX_SIZE_BYTES = 1024 * 1024

export const FIRESTORE_COLLECTIONS = Object.freeze({
  users: 'Users',
  orders: 'orders',
  shopOrders: 'ShopOrders',
  contactMessages: 'ContactMessages',
  callBack: 'CallBack',
  clinics: 'clinics',
  services: 'services',
  products: 'products',
  articles: 'articles',
  categories: 'Categories',
  generalInfo: 'GeneralInfo'
})

export const LOCAL_COLLECTION_TO_FIRESTORE = Object.freeze({
  clinics: FIRESTORE_COLLECTIONS.clinics,
  services: FIRESTORE_COLLECTIONS.services,
  products: FIRESTORE_COLLECTIONS.products,
  articles: FIRESTORE_COLLECTIONS.articles,
  orders: FIRESTORE_COLLECTIONS.orders,
  ShopOrders: FIRESTORE_COLLECTIONS.shopOrders,
  CallBack: FIRESTORE_COLLECTIONS.callBack,
  ContactMessages: FIRESTORE_COLLECTIONS.contactMessages
})

export const CATEGORY_DOCUMENTS = Object.freeze({
  serviceCategories: 'services',
  productCategories: 'products',
  articleCategories: 'articles'
})

export const GENERAL_INFO_DOCUMENTS = Object.freeze({
  general: 'general',
  pages: 'pages'
})

export const STORAGE_FOLDERS = Object.freeze({
  [FIRESTORE_COLLECTIONS.users]: 'users',
  [FIRESTORE_COLLECTIONS.orders]: 'orders',
  [FIRESTORE_COLLECTIONS.contactMessages]: 'contact-messages',
  [FIRESTORE_COLLECTIONS.callBack]: 'callback',
  [FIRESTORE_COLLECTIONS.clinics]: 'clinics',
  [FIRESTORE_COLLECTIONS.services]: 'services',
  [FIRESTORE_COLLECTIONS.products]: 'products',
  [FIRESTORE_COLLECTIONS.articles]: 'articles',
  [FIRESTORE_COLLECTIONS.categories]: 'categories',
  [FIRESTORE_COLLECTIONS.generalInfo]: 'general-info'
})

export function firestoreCollectionForLocalKey(collectionKey) {
  return LOCAL_COLLECTION_TO_FIRESTORE[collectionKey] || collectionKey
}

export function storageFolderForCollection(collectionName) {
  return STORAGE_FOLDERS[collectionName] || collectionName
}
